module.exports = __webpack_public_path__ + "img/part4-uIcon12.f0600fe1.png";